import React from 'react'
import Button from 'components/Common/Button'
import welcomeIcon from 'assets/svgs/welcome_tackle.svg'
import tw from 'twin.macro'
import styled from 'styled-components'

interface IParagraphProps {
  noTopMargin?: boolean
}

const ParagraphWrapper = styled.p<IParagraphProps>`
  ${(props: IParagraphProps) => (props.noTopMargin ? tw`m-0` : tw`my-4`)}
  ${tw`font-primary text-base font-normal leading-6 text-left`}
`
const WelcomeOwner = ({ onSubmit, firstName }) => {
  return (
    <div>
      <div className="flex text-center items-center justify-center flex-col">
        <div className="w-[100%] sm:w-[100%] md:w-[100%] lg:w-[100%]">
          <div className="flex text-center items-center justify-center my-8">
            <img className="w-[200px] h-auto mx-auto" src={welcomeIcon} alt="welcomeIcon" />
          </div>
          <h2 className="my-6 text-4xl text-left font-regular text-purple-dark font-secondary leading-10 font-body">
            {firstName}, let's tackle your business!
          </h2>
          <div>
            <ParagraphWrapper className="text-left" noTopMargin>
              GoTackle gives entrepreneurs a competitive edge, thanks to actionable data insights,
              step-by-step guidance, and real-time collaboration with their trusted business
              advisors.
            </ParagraphWrapper>
          </div>
          <div>
            <ParagraphWrapper>
              Let’s get started! There’s no stopping entrepreneurs who have the right technology,
              tools, and team.
            </ParagraphWrapper>
          </div>
        </div>
        <div className="mt-5 w-[300px] xs:w-full md:w-[400px]">
          {/* check-button - clean up custom style */}
          <Button
            className="w-full"
            fontSize="xxl"
            variant="primary"
            label="GoTackle!"
            onClick={onSubmit}
          />
        </div>
        <ParagraphWrapper className="!text-center !mt-3 italic font-normal text-base">
          This assessment takes about 1–2 minutes, and
          <br />
          can be done on a computer or phone. Your progress is automatically saved as you go.
        </ParagraphWrapper>
      </div>
    </div>
  )
}
WelcomeOwner.defaultProps = {
  firstName: '',
}
export default WelcomeOwner
